
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/navidul-gaming",
      function () {
        return require("private-next-pages/es/navidul-gaming/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/navidul-gaming"])
      });
    }
  